<template>
  <div class="for-chi" :key="item.gridid" @click="updateArticleid">
    <div v-if="item.gridid == index+1">
      <div
        v-if="!item.color && iscomplete[item.gridid-1].iscomplete == true"
        class="chi complete"
        :value="item.id"
      >
        <router-link to="/game/newspaper/1">
          <p class="chi-point" :value="item.id">{{ points[item.id-1].point }}P</p>
          <div class="chi-star-box" :value="item.id">
            <img class="chi-star" :value="item.id" src="../assets/img/top_star.png" />
          </div>
          <p class="chi-keyword" :value="item.id">{{ item.word }}</p>
        </router-link>
      </div>
      <div
        v-else-if="!item.color && iscomplete[item.gridid-1].iscomplete == false"
        class="chi"
        :value="item.id"
      >
        <router-link to="/game/5w1h">
          <p class="chi-point" :value="item.id">{{ points[item.id-1].point }}P</p>
          <p class="chi-keyword" :value="item.id">{{ item.word }}</p>
        </router-link>
      </div>
      <div
        v-else-if="!item.color && iscomplete[item.gridid-1].iscomplete == 'ing'"
        class="chi ing"
        :value="item.id"
      >
      <div class="card__corner-triangle"></div>
        <router-link to="/game/5w1h">
          <p class="chi-point" :value="item.id">{{ points[item.id-1].point }}P</p>
          <p class="chi-keyword" :value="item.id">{{ item.word }}</p>
        </router-link>
      </div>
      <div
        v-else-if="item.color && iscomplete[item.gridid-1].iscomplete == true"
        :class="item.color"
        class="chi complete"
        :value="item.id"
      >
        <router-link to="/game/newspaper/1">
          <p class="chi-point" :value="item.id">{{ points[item.id-1].point }}P</p>
          <div class="chi-star-box" :value="item.id">
            <img class="chi-star" :value="item.id" src="../assets/img/top_star.png" />
          </div>
          <p class="chi-keyword" :value="item.id">{{ item.word }}</p>
        </router-link>
      </div>
      <div
        v-else-if="item.color && iscomplete[item.gridid-1].iscomplete == false"
        :class="item.color"
        class="chi"
        :value="item.id"
      >
      <div class="card__corner">
      <div class="card__corner-triangle"></div>
   </div>
        <router-link to="/game/5w1h">
          <p class="chi-point" :value="item.id">{{ points[item.id-1].point }}P</p>
          <p class="chi-keyword" :value="item.id">{{ item.word }}</p>
        </router-link>
      </div>
      <div
        v-else-if="item.color && iscomplete[item.gridid-1].iscomplete == 'ing'"
        :class="item.color"
        class="chi ing"
        :value="item.id"
      >
        <router-link to="/game/5w1h">
          <p class="chi-point" :value="item.id">{{ points[item.id-1].point }}P</p>
          <p class="chi-keyword" :value="item.id">{{ item.word }}</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['item', 'index'],
  computed: {
    ...mapGetters({
      news: 'newsGrid',
      points: 'current_section_article_point',
      iscomplete: 'newsStates',
      current_section_id: 'current_section_id'
    })
  },
  methods: {
    updateArticleid (e) {
      this.$store.dispatch('sendUserArticle', e.target.attributes[0].value)
      this.$store.dispatch('loadhashtag', e.target.attributes[0].value)
      this.$store.dispatch('loadfwohlist', e.target.attributes[0].value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/newsItem.vue